import { Component, OnInit } from "@angular/core";
import { Subject } from "rxjs/Subject";
import { debounceTime } from "rxjs/operators";
import { DragulaService } from "ng2-dragula";
import { CategoriaService } from "../../../services/categoria/categoria.service";
import { GeneralService } from "../../../services/general/general.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { EditCategoriasComponent } from "../edit-categorias/edit-categorias.component";
import { Categoria } from "../../../../model/class/Categoria";
import { ConfirmService } from "../../../services/confirm/confirm.service";
import { ToastsManager } from "ng2-toastr/ng2-toastr";

import * as _ from "lodash";
import { forkJoin } from "rxjs/observable/forkJoin";
import { Archivo } from "../../../../model/class/Archivo";
import { EditBannerCategoriaComponent } from "../edit-banner-categoria/edit-banner-categoria.component";

@Component({
  selector: "app-categorias",
  templateUrl: "./categorias.component.html",
  styles: [],
  providers: [DragulaService],
})
export class CategoriasComponent implements OnInit {
  loader = {
    guardar: false,
    padres: true,
    intermedias: false,
    especialesMenu: false,
    hijas: false,
    search: false,
  };

  textoBuscar: string;
  textoBuscarChanged: Subject<string> = new Subject<string>();
  buscados: any[] = [];

  padreSeleccionada: Categoria;
  intermediaSeleccionada: Categoria;

  categoriasPadres: Categoria[] = [];

  cFantasiaParams = { visibility: ["MENU"] };
  bMenuParams = { per_page: 1, tipo: "CATEGORIA_BANNER_MENU" };

  constructor(
    private _generalService: GeneralService,
    private dragulaService: DragulaService,
    private categoriaService: CategoriaService,
    private modalService: NgbModal,
    private confirmService: ConfirmService,
    private toasts: ToastsManager
  ) {
    dragulaService.dropModel.subscribe((value) => {
      this.emparejarOrden();
    });

    this.textoBuscarChanged
      .pipe(debounceTime(500)) // wait 1 sec after the last event before emitting last event
      .subscribe((model) => {
        this.textoBuscar = model.toString();

        if (this.textoBuscar === "") {
          this.buscados = [];
        } else {
          this.buscarCategoriasEspeciales();
        }
      });
  }

  ngOnInit() {
    this.categoriaService.getPadresTodas().subscribe(
      (data) => {
        for (const cat of data) {
          this.categoriasPadres.push(new Categoria(cat));
        }
        this.loader.padres = false;
      },
      (error) => {
        this.loader.padres = false;
      }
    );
  }

  onTextoBuscarChange(texto: string) {
    this.loader.search = true;
    this.textoBuscarChanged.next(texto);
  }

  buscarCategoriasEspeciales() {
    let texto = this.textoBuscar.replace(new RegExp("span", "ig"), "");
    texto = _.trim(texto);
    if (texto) {
      const objetoBucar: any[] = [{ name: texto }, { category_id: "null" }];
      const parametros = { search: JSON.stringify(objetoBucar) };

      this.categoriaService.getDeFantasia(parametros).subscribe((data) => {
        for (const categoria of data) {
          this.buscados.push(new Categoria(categoria));
        }
        this.loader.search = false;
      });
    } else {
      this.buscados = [];
      this.loader.search = false;
    }
  }

  limpiarTexto() {
    this.buscados = [];
    this.textoBuscar = "";
  }

  seleccionarCategoria(categoria: Categoria, tipo: string) {
    if (tipo === "padre") {
      this.padreSeleccionada = categoria;
      this.intermediaSeleccionada = undefined;

      if (!this.padreSeleccionada.categoriasHijas) {
        this.loader.intermedias = true;
        forkJoin([
          this.categoriaService.getHijasTodas(categoria.id),
          this.categoriaService.getHijasDeFantasia(
            categoria.id,
            this.cFantasiaParams
          ),
          this.categoriaService.getArchivos(categoria.id, this.bMenuParams),
        ]).subscribe((data) => {
          this.loader.intermedias = false;
          this.padreSeleccionada.categoriasHijas = [];
          this.padreSeleccionada.hijasFantasia = [];
          for (const cat of data[0]) {
            this.padreSeleccionada.categoriasHijas.push(new Categoria(cat));
          }
          for (const cat of data[1]) {
            this.padreSeleccionada.hijasFantasia.push(new Categoria(cat));
          }
          if (data[2][0]) {
            this.padreSeleccionada.bannerMenu = new Archivo(data[2][0]);
          }
        });
      }
    } else if (tipo === "intermedia") {
      this.intermediaSeleccionada = categoria;

      if (!this.intermediaSeleccionada.categoriasHijas) {
        this.loader.hijas = true;
        this.categoriaService.getHijasTodas(categoria.id).subscribe((data) => {
          this.loader.hijas = false;
          this.intermediaSeleccionada.categoriasHijas = [];
          for (const cat of data) {
            this.intermediaSeleccionada.categoriasHijas.push(
              new Categoria(cat)
            );
          }
        });
      }
    }
  }

  emparejarOrden() {
    _.each(this.categoriasPadres, (padre: Categoria, i) => {
      padre.nuevoOrden = i + 1;
      if (padre.categoriasHijas) {
        _.each(padre.categoriasHijas, (intermedia: Categoria, x) => {
          intermedia.nuevoOrden = x + 1;
          if (intermedia.categoriasHijas) {
            _.each(intermedia.categoriasHijas, (hija: Categoria, y) => {
              hija.nuevoOrden = y + 1;
            });
          }
        });
      }
    });
  }

  editarCategoria(nivel: number, categoria?: Categoria) {
    let clon: any = {};
    let padre: any = {};

    if (categoria) {
      clon = _.clone(categoria);
    }

    if (nivel === 2) {
      padre = this.padreSeleccionada;
    } else if (nivel === 3) {
      padre = this.intermediaSeleccionada;
    }

    const viewModal = this.modalService.open(EditCategoriasComponent, {
      size: "lg",
      windowClass: "modal-admin",
    });
    viewModal.componentInstance.newCategoria = clon;
    viewModal.componentInstance.nivel = nivel;
    viewModal.componentInstance.padre = padre;

    viewModal.result.then(
      (newCategoria: Categoria) => {
        let destino: any[];

        if (nivel === 1) {
          destino = this.categoriasPadres;
        } else if (nivel === 2) {
          destino = this.padreSeleccionada.categoriasHijas;
        } else if (nivel === 3) {
          destino = this.intermediaSeleccionada.categoriasHijas;
        }

        const index = _.findIndex(destino, { id: newCategoria.id });

        if (index >= 0) {
          destino[index] = newCategoria;
        } else {
          destino.push(newCategoria);
        }

        this.emparejarOrden();
      },
      (reason) => {
      }
    );
    this._generalService.revalidarPathCache("categories/all").subscribe();
    this._generalService.revalidarPathCache("categories/products").subscribe();
    this._generalService.revalidarPathCache("categories/menu").subscribe();
    this._generalService.revalidarPathCache("categories/sidemenu").subscribe();
    this._generalService.revalidarPathCache("categories/current").subscribe();
  }

  eliminar(nivel, id) {
    this.confirmService
      .confirm(
        "Eliminar",
        "¿Seguro que desea eliminar este Categoria y todas sus categorias hijas?"
      )
      .then((resp) => {
        if (resp) {
          this.categoriaService.delete(id).subscribe(
            (data) => {
              this.toasts.success("Categoria eliminada con éxito");

              if (nivel === 1) {
                _.remove(this.categoriasPadres, { id: id });
                this.padreSeleccionada = undefined;
              } else if (nivel === 2) {
                _.remove(this.padreSeleccionada.categoriasHijas, { id: id });
              } else if (nivel === 3) {
                _.remove(this.intermediaSeleccionada.categoriasHijas, {
                  id: id,
                });
              }
            },
            (error) => {
              console.log(error);
              this.toasts.error("Error al eliminar la Categoria");
            }
          );
        }
      });
    this._generalService.revalidarPathCache("categories/all").subscribe();
    this._generalService.revalidarPathCache("categories/products").subscribe();
    this._generalService.revalidarPathCache("categories/menu").subscribe();
    this._generalService.revalidarPathCache("categories/sidemenu").subscribe();
    this._generalService.revalidarPathCache("categories/current").subscribe();
  }

  guardarOrden() {
    this.loader.guardar = true;

    const reqOeden = [];

    for (const padre of this.categoriasPadres) {
      if (padre.orden !== padre.nuevoOrden) {
        reqOeden.push(
          this.categoriaService.edit(padre.id, padre.getFormDataNuevoOrden())
        );
      } else {
        reqOeden.push(
          new Promise<void>((resolve, reject) => {
            resolve();
          })
        );
      }
      if (padre.categoriasHijas) {
        for (const intermedia of padre.categoriasHijas) {
          if (intermedia.orden !== intermedia.nuevoOrden) {
            reqOeden.push(
              this.categoriaService.edit(
                intermedia.id,
                intermedia.getFormDataNuevoOrden()
              )
            );
          }
          if (intermedia.categoriasHijas) {
            for (const hija of intermedia.categoriasHijas) {
              if (hija.orden !== hija.nuevoOrden) {
                reqOeden.push(
                  this.categoriaService.edit(
                    hija.id,
                    hija.getFormDataNuevoOrden()
                  )
                );
              }
            }
          }
        }
      }
    }

    forkJoin(reqOeden).subscribe(
      (data) => {
        this.loader.guardar = false;
        this._generalService.revalidarPathCache("categories/all").subscribe();
        this._generalService
          .revalidarPathCache("categories/products")
          .subscribe();
        this._generalService.revalidarPathCache("categories/menu").subscribe();
        this._generalService
          .revalidarPathCache("categories/sidemenu")
          .subscribe();
        this._generalService
          .revalidarPathCache("categories/current")
          .subscribe();
        this.toasts.success("Orden actualizado con exito");
      },
      (error) => {
        this.loader.guardar = false;
        console.log(error);
        this.toasts.error("Error al actualizar el Orden");
      }
    );
  }

  agregarEspecial(categoria: Categoria) {
    this.loader.especialesMenu = true;

    categoria.categoriaId = this.padreSeleccionada.id;
    if (categoria.visibleEn.indexOf("MENU") === -1) {
      categoria.visibleEn.push("MENU");
    }
    const formData = categoria.getFormDataVisibleEn();
    formData.append("categoriaId", String(categoria.categoriaId));

    this.limpiarTexto();

    this.categoriaService.edit(categoria.id, formData).subscribe(
      (data) => {
        this.toasts.success("Categoria especial agregada");
        if (!this.padreSeleccionada.hijasFantasia) {
          this.padreSeleccionada.hijasFantasia = [];
        }
        this.padreSeleccionada.hijasFantasia.push(categoria);
        this.loader.especialesMenu = false;
      },
      (error) => {
        this.toasts.error("Error al agregar la categoria especial");
        this.loader.especialesMenu = false;
      }
    );
  }

  quitarEspecial(categoria: Categoria) {
    this.loader.especialesMenu = true;

    const indice = categoria.visibleEn.indexOf("MENU");
    if (indice >= 0) {
      categoria.visibleEn.splice(indice, 1);
    }

    const formData = categoria.getFormDataVisibleEn();
    formData.append("categoriaId", "0");

    this.categoriaService.edit(categoria.id, formData).subscribe(
      (data) => {
        this.toasts.success("Categoria especial quitada");
        _.remove(this.padreSeleccionada.hijasFantasia, { id: categoria.id });
        this.loader.especialesMenu = false;
      },
      (error) => {
        this.toasts.error("Error al quitar la categoria especial");
        this.loader.especialesMenu = false;
      }
    );
  }

  editarBannerCategoria(banner?: Archivo) {
    let clon: Archivo;

    if (banner) {
      clon = _.clone(banner);
    } else {
      clon = new Archivo({
        id: -1,
        tipo: "CATEGORIA_BANNER_MENU",
      });
    }

    const viewModal = this.modalService.open(EditBannerCategoriaComponent, {
      size: "lg",
      windowClass: "modal-admin",
    });
    viewModal.componentInstance.banner = clon;
    viewModal.componentInstance.padre = this.padreSeleccionada;

    viewModal.result.then(
      (newBanner: Archivo) => {
        this.padreSeleccionada.bannerMenu = newBanner;
      },
      (reason) => {}
    );
  }

  eliminarBanner(banner: Archivo) {
    this.confirmService
      .confirm("Eliminar", "¿Seguro que desea eliminar este Banner?")
      .then((resp) => {
        if (resp) {
          this.categoriaService
            .deletaArchivo(this.padreSeleccionada.id, banner.id)
            .subscribe(
              (data) => {
                this.toasts.success("Banner eliminado con éxito");

                this.padreSeleccionada.bannerMenu = undefined;
              },
              (error) => {
                console.log(error);
                this.toasts.error("Error al eliminar el Banner");
              }
            );
        }
      });
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/categorias/categorias.component.ts